import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.faceScale.loading;
export const faceScaleErrorMessage = (state: RootState) =>
  state.faceScale.error;
export const faceScaleDataResponse = (state: RootState) =>
  state.faceScale.faceScaleResponse;
